if (!customElements.get("lazy-section")) {
  customElements.define(
    "lazy-section",
    class LazySection extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.fetchKey = this.dataset.fetchKey;
        this.replaceSelector = this.dataset.replaceSelector;
        this.path = this.dataset.path;

        if (
          !this.sectionId ||
          !this.fetchKey ||
          !this.replaceSelector ||
          !this.path
        )
          return;

        this.loadLazySection();
      }

      async loadLazySection() {
        var section_markup = await this.fetchSection();

        if (!section_markup) return;

        this.renderAndReplace(section_markup);
      }

      async fetchSection() {
        const fetch_url = `${this.path}/${this.fetchKey}?sections=${this.sectionId}`;

        return fetch(fetch_url)
          .then((response) => response.json())
          .then((data) => {
            return data[this.sectionId];
          })
          .catch((e) => {
            debugger;
          });
      }

      renderAndReplace(markupText) {
        var html = new DOMParser().parseFromString(markupText, "text/html");

        var new_el = html.querySelector(this.replaceSelector);
        var old_el = this.querySelector(this.replaceSelector);

        if (!new_el || !old_el) {
          console.error("Error loading LazySection html");
          return;
        }

        old_el.replaceWith(new_el);

        document.dispatchEvent(new CustomEvent("section-loaded-replaced"));
      }
    },
  );
}
